"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
class UserSchoolInfoDoesNotExistError extends client_library_1.ExtendableError {
    constructor() {
        super(`School info does not exist for user`);
    }
}
exports.default = UserSchoolInfoDoesNotExistError;
//# sourceMappingURL=UserSchoolInfoDoesNotExistError.js.map